import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { JwtModule } from '@auth0/angular-jwt';
import { environment } from '@environments/environment';
import { TranslationUtilsModule } from '@myscania/translation-utils-angular';
import { NoInternetToastrComponent } from '@shared/components/no-internet-toastr/no-internet-toastr.component';
import { NoNetworkComponent } from '@shared/components/no-network/no-network.component';
import { loadAdobeAnalytics } from '@shared/init/adobe-analytics-loader';
import { ENVIRONMENT_TOKEN } from '@shared/models/environment.model';
import { SharedModule } from '@shared/shared.module';
import { ToastModule } from '@teamsp/components/toast';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuardService } from './auth/auth-guard.service';
import { AuthService } from './auth/auth.service';

@NgModule({
  declarations: [AppComponent, NoInternetToastrComponent, NoNetworkComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    CommonModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    SharedModule,
    ToastModule.forRoot({ position: 'bottom-right', duration: 3000, closable: true, edgeMargin: '1.6rem' }),
    TranslationUtilsModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => window.sessionStorage.getItem('access_token'),
        allowedDomains: [environment.serviceBaseServicePlanningDomain]
      }
    })
  ],
  exports: [],
  providers: [
    AuthGuardService,
    AuthService,
    { provide: ENVIRONMENT_TOKEN, useValue: environment },
    provideAppInitializer(loadAdobeAnalytics),
    provideHttpClient()
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
